import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
/** Services Import */
import Global from "../Services/Common/Global";
import Commons from "../Services/Common/Common";
import IndexedDb from "../Services/IndexedDb/IndexedDb";
import TranslationService from "../Services/Translation/TranslationService";
/** Redux Import */
import { useSelector, useDispatch } from "react-redux";
import { LocalStorageActions } from "../Redux-Reducer/LocalStorageReducer";
/** Styles Import */
import "./Style.css";
/** Components Import */
import {
  Container,
  Button,
  Dropdown,
  Offcanvas,
  ListGroup,
  Modal,
  Form,
} from "react-bootstrap";
import SearchInput from "../Components/SearchInput";
import Dialog from "../Components/Dialog";
import Swal from "../Components/SweetAlert2";
import AutoTranslate from "../Components/AutoTranslate";
/** Icons Import */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMagnifyingGlass,
  faBars,
  faArrowLeft,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
/** Images Import */
import Logo from "../Assets/Images/SafeWay_logo_thumb.png";

function Drawer() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [userInfo, setUserInfo] = useState(null);
  const searchText = useSelector((state) => state.localStorage.searchText);
  const authorization = useSelector(
    (state) => state.localStorage.authorization,
  );
  const [menuShow, setMenuShow] = useState(false);
  const [showDialog, setShowDialog] = useState(false); // 로그인 유형 선택
  const [showDialog1, setShowDialog1] = useState(false); // 검색 창 띄우기
  const [nationalityList, setNationalityList] = useState([]);
  const language = useSelector((state) => state.localStorage.language);
  const [wording, setWording] = useState({
    searchPlaceholder: "검색",
    loginDialogTitle: "유형 선택",
    warningMessage: "준비중입니다.",
  });

  useEffect(() => {
    Init();

    // 페이지 로드 시 미디어 세션 초기화
    Commons.disableMediaSession();
  }, []);

  // 라우트 변경 감지 및 미디어 정리
  useEffect(() => {
    console.log("[Drawer] 라우트 변경 감지:", location.pathname);

    const videoPages = ["/watch", "/watch-education"];

    // 비디오 페이지로 이동할 때는 미디어 정리하지 않음
    if (videoPages.includes(location.pathname)) {
      console.log("[Drawer] 비디오 페이지로 이동 - 미디어 정리 건너뜀");
      return;
    }

    // 비디오 페이지가 아닌 다른 페이지로 이동할 때만 미디어 정리
    const hasReactPlayerElements =
      document.querySelectorAll('[data-testid="react-player"]').length > 0;
    if (hasReactPlayerElements) {
      console.log(
        "[Drawer] ReactPlayer가 있는 페이지에서 다른 페이지로 이동 - 미디어 정리 실행",
      );
      Commons.cleanupMediaElements();
      Commons.disableMediaSession();
    }
  }, [location.pathname]);

  // 페이지 떠날 때 미디어 정리
  useEffect(() => {
    const handleBeforeUnload = () => {
      console.log("[Drawer] 페이지 떠남 - 미디어 정리 실행");
      Commons.cleanupMediaElements();
      Commons.disableMediaSession();
    };

    const handleVisibilityChange = () => {
      if (document.hidden) {
        // 비디오 페이지에서는 탭 전환 시에도 미디어 정리를 하지 않음
        const videoPages = ["/watch", "/watch-education"];
        if (videoPages.includes(location.pathname)) {
          console.log(
            "[Drawer] 비디오 페이지에서 탭 전환 감지 - 미디어 정리 건너뜀",
          );
          return;
        }

        console.log("[Drawer] 페이지 숨김 - 미디어 정리 실행");
        Commons.cleanupMediaElements();
        Commons.disableMediaSession();
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [location.pathname]);

  const Init = async () => {
    try {
      console.log("authorization: ", authorization);
      const _userData = await IndexedDb.GetUserInfo();
      setUserInfo(_userData);
      await Search2();
      const _searchPlaceholder = await TranslationService.translateText(
        "검색",
        language.lang,
      );
      const _loginDialogTitle = await TranslationService.translateText(
        "유형 선택",
        language.lang,
      );
      const _warningMessage = await TranslationService.translateText(
        "준비중입니다.",
        language.lang,
      );
      setWording({
        searchPlaceholder: _searchPlaceholder,
        loginDialogTitle: _loginDialogTitle,
        warningMessage: _warningMessage,
      });
    } catch (e) {
      console.log("Init error: ", e);
    }
  };

  // 메인 컨텐츠 조회
  const Search = async () => {
    try {
      if (!searchText) {
        return;
      }
      let params = searchText ? { q: searchText } : {};
      await Commons.Axios(
        "get",
        Global.base.useUrl + Global.urls.Content.Search,
        params,
      ).then((result) => {
        let data = result.data;
        console.log("Search: ", data);

        if (!data) {
          throw new Error(data);
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          if (location.pathname !== "/search-result") {
            navigate("/search-result", {
              state: { data: data, searchText: searchText },
            });
          } else {
            navigate(location.pathname, {
              state: { data: data, searchText: searchText },
              replace: true,
            });
          }
        }
      });
    } catch (e) {
      console.log("Search Error: ", e);
    } finally {
    }
  };

  const Search1 = async (_param) => {
    try {
      const result = await Commons.Axios(
        "get",
        Global.base.useUrl + Global.urls.Content.Search,
        { q: _param },
      );
      const data = result.data;
      if (!data) throw new Error(data);
      if (data.type === "Error") throw new Error(data.message);
      navigate("/search-result", { state: { data: data, searchText: _param } });
    } catch (e) {
      console.log("Search1 Error: ", e);
    }
  };

  // 국가 목록 가져오는 로직
  const Search2 = async () => {
    try {
      const response = await Commons.Axios(
        "get",
        Global.base.useUrl + Global.urls.Common.notAuthGetCode,
        { code: "NATIONALITY" },
      );
      // console.log("Search2 response: ", response.data);
      if (response.status === 200) {
        if (Array.isArray(response.data)) {
          setNationalityList(response.data);
        } else {
          throw new Error(response.data);
        }
      } else {
        throw new Error(response.data);
      }
    } catch (e) {
      console.log("Search2 error: ", e);
    }
  };

  // 로그아웃 로직
  const Sumit = async () => {
    try {
      // 먼저 Redux 상태를 업데이트
      dispatch(
        LocalStorageActions.setAuthorization({
          auth: false,
          authDate: "",
          authType: "",
        }),
      );
      // 로컬 스토리지에서 사용자 정보 삭제
      Commons.Storages("set", "userInfo", { userId: "", userName: "" });
      // IndexedDB에서 사용자 정보 삭제
      await IndexedDb.ClearTable("UserInfo");
      // Redux 상태 업데이트가 완료된 후 메인 페이지로 이동
      setTimeout(() => {
        // 강제로 메인 페이지로 이동하고 페이지 새로고침
        window.location.href = "/";
      }, 100);
    } catch (e) {
      console.log("로그아웃 오류: ", e);
      // 에러가 발생해도 메인 페이지로 이동
      setTimeout(() => {
        window.location.href = "/";
      }, 100);
    }
  };

  return (
    <div className="drawer">
      <Container
        className={`py-3 ${Commons.IsMobile() ? "px-3" : "px-5"}`}
        fluid={Commons.IsMobile() ? false : true}
      >
        <div className="flex-between align-items-center gap-3 mb-3 drawer-top-container">
          <div
            className="cursor-pointer me-2"
            onClick={() => {
              navigate("/");
              dispatch(LocalStorageActions.setSearchText(""));
            }}
          >
            {/* <span style={{ fontSize: "2rem", fontWeight: "bold", color: "#03bbfe" }}>SAFEWAY</span> */}
            <img src={Logo} alt="logo" style={{ width: "200px" }} />
          </div>
          {Commons.IsMobile() ? (
            <div className="flex-end gap-2">
              <Button variant="dark" onClick={() => setShowDialog1(true)}>
                <FontAwesomeIcon icon={faMagnifyingGlass} />
              </Button>
              <Button variant="dark" onClick={() => setMenuShow(true)}>
                <FontAwesomeIcon icon={faBars} />
              </Button>
              <Offcanvas
                placement="end"
                show={menuShow}
                onHide={() => setMenuShow(false)}
              >
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title>MENU</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  {!authorization.auth && (
                    <div className="flex-end mb-3">
                      <Dropdown>
                        <Dropdown.Toggle
                          className="px-3"
                          size="sm"
                          variant="light"
                        >
                          <img
                            src={language.flag}
                            alt={language.name}
                            style={{
                              width: "30px",
                              height: "20px",
                              marginRight: "1rem",
                            }}
                          />
                          {language.name}
                        </Dropdown.Toggle>
                        <Dropdown.Menu
                          variant="light"
                          style={{ maxHeight: "300px", overflowY: "auto" }}
                        >
                          {Array.isArray(nationalityList) &&
                            nationalityList.map((item, index) => {
                              return (
                                <Dropdown.Item
                                  key={index}
                                  onClick={async () => {
                                    dispatch(
                                      LocalStorageActions.setLanguage(item),
                                    );
                                    Commons.Storages("set", "language", item);
                                    const _searchPlaceholder =
                                      await TranslationService.translateText(
                                        "검색",
                                        item.lang,
                                      );
                                    const _loginDialogTitle =
                                      await TranslationService.translateText(
                                        "유형 선택",
                                        item.lang,
                                      );
                                    setWording({
                                      searchPlaceholder: _searchPlaceholder,
                                      loginDialogTitle: _loginDialogTitle,
                                    });
                                  }}
                                >
                                  <img
                                    src={item.flag}
                                    alt={item.name}
                                    style={{
                                      width: "30px",
                                      height: "20px",
                                      marginRight: "1rem",
                                    }}
                                  />
                                  {item.name}
                                </Dropdown.Item>
                              );
                            })}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  )}
                  <ListGroup className="mb-3">
                    {authorization.authType === "e" && authorization.auth && (
                      <ListGroup.Item
                        action
                        eventKey={0}
                        onClick={() => {
                          setMenuShow(false);
                          navigate("/my-calendar");
                        }}
                      >
                        <AutoTranslate targetLanguage={language.lang}>
                          교육 일정
                        </AutoTranslate>
                      </ListGroup.Item>
                    )}
                    {authorization.auth && (
                      <ListGroup.Item
                        action
                        eventKey={1}
                        onClick={() => {
                          setMenuShow(false);
                          if (userInfo.auth === "BIZ") {
                            navigate("/selected-site");
                          } else {
                            navigate("/selected-company");
                          }
                        }}
                      >
                        <AutoTranslate targetLanguage={language.lang}>
                          MY 교육 현황
                        </AutoTranslate>
                      </ListGroup.Item>
                    )}
                    <ListGroup.Item
                      action
                      eventKey={2}
                      onClick={() => {
                        setMenuShow(false);
                        Search1("예능");
                      }}
                    >
                      <AutoTranslate targetLanguage={language.lang}>
                        안방TV
                      </AutoTranslate>
                    </ListGroup.Item>
                    <ListGroup.Item
                      action
                      eventKey={3}
                      onClick={() => {
                        setMenuShow(false);
                        Swal.warning(wording.warningMessage);
                      }}
                    >
                      <AutoTranslate targetLanguage={language.lang}>
                        포인트샵
                      </AutoTranslate>
                    </ListGroup.Item>
                  </ListGroup>
                  {authorization.auth ? (
                    <React.Fragment>
                      <ListGroup>
                        {authorization.authType === "e" && (
                          <ListGroup.Item
                            onClick={() => {
                              setMenuShow(false);
                              const manualUrl = "/manual.pdf";
                              const link = document.createElement("a");
                              link.href = manualUrl;
                              link.download = "SafeWay_Manual.pdf";
                              link.style.display = "none";
                              document.body.appendChild(link);
                              link.click();
                              setTimeout(() => {
                                try {
                                  if (typeof link.remove === "function") {
                                    link.remove();
                                  } else if (link.parentNode) {
                                    link.parentNode.removeChild(link);
                                  }
                                } catch (e) {
                                  // ignore cleanup errors
                                }
                              }, 0);
                            }}
                          >
                            <AutoTranslate targetLanguage={language.lang}>
                              메뉴얼 다운로드
                            </AutoTranslate>
                          </ListGroup.Item>
                        )}
                        <ListGroup.Item
                          onClick={() => {
                            setMenuShow(false);
                            navigate("/my-page");
                          }}
                        >
                          <AutoTranslate targetLanguage={language.lang}>
                            마이페이지
                          </AutoTranslate>
                        </ListGroup.Item>
                        <ListGroup.Item onClick={Sumit}>
                          <AutoTranslate targetLanguage={language.lang}>
                            로그아웃
                          </AutoTranslate>
                        </ListGroup.Item>
                      </ListGroup>
                    </React.Fragment>
                  ) : (
                    <ListGroup>
                      <ListGroup.Item
                        action
                        eventKey={4}
                        onClick={() => {
                          setMenuShow(false);
                          setShowDialog(true);
                        }}
                      >
                        <AutoTranslate targetLanguage={language.lang}>
                          로그인
                        </AutoTranslate>
                      </ListGroup.Item>
                    </ListGroup>
                  )}
                </Offcanvas.Body>
              </Offcanvas>
            </div>
          ) : (
            <div className="w-100">
              {location.pathname !== "/selected-company" &&
                location.pathname !== "/selected-site" && (
                  <SearchInput
                    autoFocus={true}
                    isEndSearchIcon
                    placeholder={wording.searchPlaceholder}
                    text={searchText}
                    setText={(e) =>
                      dispatch(LocalStorageActions.setSearchText(e))
                    }
                    onSumit={() => Search()}
                  />
                )}
            </div>
          )}
          <div className="flex-end gap-3 ms-5 drawer-top-menu">
            {authorization.authType === "e" && authorization.auth && (
              <Button
                className="drawer-top-btn"
                variant="dark"
                size="sm"
                onClick={() => navigate("/my-calendar")}
              >
                {/* 보건&#183;안전교육 */}
                <AutoTranslate targetLanguage={language.lang}>
                  교육 일정
                </AutoTranslate>
              </Button>
            )}
            {authorization.auth && (
              <Button
                className="drawer-top-btn"
                variant="dark"
                size="sm"
                onClick={() => {
                  if (userInfo.auth === "BIZ") {
                    navigate("/selected-site");
                  } else {
                    navigate("/selected-company");
                  }
                }}
              >
                <AutoTranslate targetLanguage={language.lang}>
                  MY 교육 현황
                </AutoTranslate>
              </Button>
            )}
            <Button
              className="drawer-top-btn"
              variant="dark"
              size="sm"
              onClick={() => Search1("예능")}
            >
              <AutoTranslate targetLanguage={language.lang}>
                안방TV
              </AutoTranslate>
            </Button>
            <Button
              className="drawer-top-btn"
              variant="dark"
              size="sm"
              onClick={() => Swal.warning(wording.warningMessage)}
            >
              <AutoTranslate targetLanguage={language.lang}>
                포인트샵
              </AutoTranslate>
            </Button>
            {authorization.auth ? (
              <Dropdown>
                <Dropdown.Toggle className="px-3" variant="dark" size="sm">
                  <AutoTranslate
                    targetLanguage={language.lang}
                  >{`${Commons.Storages("get", "userInfo").userName} 님 환영합니다.`}</AutoTranslate>
                </Dropdown.Toggle>
                <Dropdown.Menu variant="dark">
                  {authorization.authType === "e" && (
                    <>
                      <Dropdown.Item
                        onClick={() => {
                          const manualUrl = "/manual.pdf";
                          window.open(manualUrl, "_blank");
                        }}
                      >
                        <AutoTranslate targetLanguage={language.lang}>
                          메뉴얼 다운로드
                        </AutoTranslate>
                      </Dropdown.Item>
                      <Dropdown.Divider />
                    </>
                  )}
                  <Dropdown.Item onClick={() => navigate("/my-page")}>
                    <AutoTranslate targetLanguage={language.lang}>
                      마이페이지
                    </AutoTranslate>
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item onClick={Sumit}>
                    <AutoTranslate targetLanguage={language.lang}>
                      로그아웃
                    </AutoTranslate>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              <Button
                className="drawer-top-btn"
                variant="dark"
                size="sm"
                onClick={() => setShowDialog(true)}
              >
                <AutoTranslate targetLanguage={language.lang}>
                  로그인
                </AutoTranslate>
              </Button>
            )}
            {!authorization.auth && (
              <Dropdown>
                <Dropdown.Toggle className="px-3" variant="dark" size="sm">
                  <img
                    src={language.flag}
                    alt={language.name}
                    style={{
                      width: "30px",
                      height: "20px",
                      marginRight: "1rem",
                    }}
                  />
                  {language.name}
                </Dropdown.Toggle>
                <Dropdown.Menu
                  variant="dark"
                  style={{ maxHeight: "300px", overflowY: "auto" }}
                >
                  {Array.isArray(nationalityList) &&
                    nationalityList.map((item, index) => {
                      return (
                        <Dropdown.Item
                          key={index}
                          onClick={async () => {
                            dispatch(LocalStorageActions.setLanguage(item));
                            Commons.Storages("set", "language", item);
                            const _searchPlaceholder =
                              await TranslationService.translateText(
                                "검색",
                                item.lang,
                              );
                            const _loginDialogTitle =
                              await TranslationService.translateText(
                                "유형 선택",
                                item.lang,
                              );
                            setWording({
                              searchPlaceholder: _searchPlaceholder,
                              loginDialogTitle: _loginDialogTitle,
                            });
                          }}
                        >
                          <img
                            src={item.flag}
                            alt={item.name}
                            style={{
                              width: "30px",
                              height: "20px",
                              marginRight: "1rem",
                            }}
                          />
                          {item.name}
                        </Dropdown.Item>
                      );
                    })}
                </Dropdown.Menu>
              </Dropdown>
            )}
          </div>
        </div>
        <Outlet />
      </Container>
      <Dialog
        show={showDialog}
        onHide={() => setShowDialog(false)}
        title={wording.loginDialogTitle}
        footer={false}
        dialogClassName="modern-login-dialog"
      >
        <div className="modern-login-container">
          <div className="modern-login-card">
            <h3 className="modern-login-title">
              <AutoTranslate targetLanguage={language.lang}>
                관리자
              </AutoTranslate>
            </h3>
            <p className="modern-login-desc">
              <AutoTranslate targetLanguage={language.lang}>
                안전한 서비스 이용을 위해 로그인해 주세요.
              </AutoTranslate>
            </p>
            <Button
              className="modern-login-btn business"
              onClick={() => {
                setShowDialog(false);
                navigate("/login", { state: { type: "business" } });
              }}
            >
              <AutoTranslate targetLanguage={language.lang}>
                관리자 로그인
              </AutoTranslate>
            </Button>
          </div>
          <div className="modern-login-card">
            <h3 className="modern-login-title">
              <AutoTranslate targetLanguage={language.lang}>
                근로자
              </AutoTranslate>
            </h3>
            <p className="modern-login-desc">
              <AutoTranslate targetLanguage={language.lang}>
                교육과 정보를 확인하려면 로그인하세요.
              </AutoTranslate>
            </p>
            <Button
              className="modern-login-btn worker"
              onClick={() => {
                setShowDialog(false);
                navigate("/login", { state: { type: "worker" } });
              }}
            >
              <AutoTranslate targetLanguage={language.lang}>
                근로자 로그인
              </AutoTranslate>
            </Button>
          </div>
        </div>
      </Dialog>
      <Modal show={showDialog1} onHide={() => setShowDialog1(false)} fullscreen>
        <Form
          className="drawer-modal-form"
          onSubmit={(e) => {
            e.preventDefault();
            setShowDialog1(false);
            Search();
          }}
        >
          <Form.Group className="drawer-modal-form-group">
            <div style={{ position: "relative", width: "100%" }}>
              <FontAwesomeIcon
                className={`drawer-modal-search-icon-start`}
                icon={faArrowLeft}
                onClick={() => {
                  dispatch(LocalStorageActions.setSearchText(""));
                  setShowDialog1(false);
                }}
              />
              <Form.Control
                className="drawer-modal-form-control"
                type="text"
                autoFocus={true}
                placeholder={wording.searchPlaceholder}
                value={searchText}
                onChange={(e) =>
                  dispatch(LocalStorageActions.setSearchText(e.target.value))
                }
              />
              <FontAwesomeIcon
                className="drawer-modal-search-icon-end"
                icon={faXmark}
                onClick={() => dispatch(LocalStorageActions.setSearchText(""))}
              />
            </div>
          </Form.Group>
        </Form>
      </Modal>
    </div>
  );
}

export default Drawer;
